package org.example.zone360.pages.coachDetails.sessionAllDetails

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaTriangleExclamation
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.getClubCoaches
import org.example.zone360.utils.getClubPlayer
import org.example.zone360.utils.getNamesById
import org.example.zone360.utils.getSentences
import org.example.zone360.utils.getSessionKeywords
import org.example.zone360.utils.getSingleCoach
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CompletableDeferred
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.Job
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.suspendCancellableCoroutine
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.formatSessionDate
import org.example.zone360.components.formatSessionHoursAmPm
import org.example.zone360.components.formatSessionMinutes
import org.example.zone360.components.rememberWidgetRenderers
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetClubPlayerData
import org.example.zone360.models.GetNamesByIdData
import org.example.zone360.models.GetNamesByIdPayload
import org.example.zone360.models.GetSentencesData
import org.example.zone360.models.GetSessionKeywordsData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.models.SessionMatchAnalysis
import org.example.zone360.pages.coachDetails.charts.CircularProgressIndicator
import org.example.zone360.pages.coachDetails.sessionAllDetails.components.FullSessionSectionUI
import org.example.zone360.pages.coachDetails.sessionAllDetails.emotionsBox.EmotionsBox
import org.example.zone360.pages.coachDetails.sessionAllDetails.sentimentsBox.SentimentBox
import org.example.zone360.pages.coachDetails.sessionAllDetails.sessionEmphasis.SessionEmphasisBreakdown
import org.example.zone360.pages.coachDetails.sessionAllDetails.speakingBox.SpeakingSub
import org.example.zone360.pages.coachDetails.sessionAllDetails.summaryBox.SummaryBox
import org.example.zone360.pages.coachDetails.sessionAllDetails.toneAnalysis.ToneAnalysisBox
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.pages.widgets.matchAnalysisWidget.MatchAnalysisWidget
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.APIEndPoints
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.mediaManagerUtils.AudioManager
import org.example.zone360.utils.Config
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.Strings
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.accept
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.Audio
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLVideoElement
import org.w3c.dom.url.URL
import org.w3c.fetch.RequestInit
import org.w3c.files.Blob
import org.w3c.files.File
import org.w3c.files.FileReader
import org.w3c.files.get
import org.w3c.xhr.FormData
import org.w3c.xhr.XMLHttpRequest
import kotlin.collections.set
import kotlin.coroutines.resumeWithException
import kotlin.js.Promise
import kotlin.math.ceil

// Global object to store upload states
object UploadStateManager {
    private val uploadStates = mutableMapOf<String, Pair<Double, String>>()
    private val sessionUpdates =
        mutableMapOf<String, (String) -> Unit>() // Store update callbacks per session

    fun getUploadProgress(sessionId: String): Double = uploadStates[sessionId]?.first ?: -1.0
    fun getUploadStatus(sessionId: String): String = uploadStates[sessionId]?.second ?: ""
    fun setUploadState(sessionId: String, progress: Double, status: String) {
        uploadStates[sessionId] = progress to status
    }

    fun setSessionUpdateCallback(sessionId: String, callback: (String) -> Unit) {
        sessionUpdates[sessionId] = callback
    }

}

@OptIn(ExperimentalCoroutinesApi::class)
@Composable
fun SessionAllDetails(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    sessionData1: GetSessionsData,
    videoUrlFile: (GetSessionsData) -> Unit,
    updateCoachInfo: (GetSingleCoachData) -> Unit,
    message: (String) -> Unit,
    selectedTeam: List<String>,
    sessionType: SelectedData,
    selectedWidgetIds: Set<Int>,
    userId: String,
    disable: Boolean,
    teamIds: List<String>,
) {

    val scope = rememberCoroutineScope()
    var sessionData by remember { mutableStateOf(GetSessionsData()) }
    val sessionKeywords = remember { mutableStateListOf<GetSessionKeywordsData>() }
//
    var videoProgress1 by remember { mutableStateOf(0f) }
    var isSeeking1 by remember { mutableStateOf(false) }
    var fullSessionVideo by remember { mutableStateOf(false) }
    var currentlyPlayingVideoId1 by remember { mutableStateOf<String?>(null) }
    val currentVideoRef1 = remember { mutableStateOf<HTMLVideoElement?>(null) }
    var isVideoDurationPlaying1 by remember { mutableStateOf(false) }
    val currentAudioRefHighlight1 = remember { mutableStateOf<Audio?>(null) }
    val sessionId1 = sessionData.sessionId
    var audioProgress1 by remember { mutableStateOf(0f) }
    var isBuffering1 by remember { mutableStateOf(false) }
    var manualSeekTriggered by remember { mutableStateOf(false) }

    var isCustomHighlight by remember { mutableStateOf(false) }
    var seekWhenPaused by remember { mutableStateOf<Double?>(null) }
    var secondSeekbar by remember { mutableStateOf(true) }
    var allowProgressUpdate by remember { mutableStateOf(true) }

    var selectedKeyword by remember { mutableStateOf<String?>(null) }
    var highlightSegments by remember { mutableStateOf<List<Pair<Float, Float>>>(emptyList()) }
    var currentKeywordSegmentIndex by remember { mutableStateOf(0) }
    var currentSegmentTime by remember { mutableStateOf<Pair<String, String>?>(null) }
    var seekTimeForHighlight by remember { mutableStateOf<Double?>(null) }
    var sliderStartTime by remember { mutableStateOf(0.0) }
    var sliderEndTime by remember { mutableStateOf(0.0) }
    var useOriginalAudio by remember { mutableStateOf(false) }
    var isAudioDurationPlaying by remember { mutableStateOf(false) }
    var stopPaginationSize by remember { mutableStateOf(false) }
    var playAllHide by remember { mutableStateOf(false) }
    var currentVideoTime by remember { mutableStateOf(0.0) }
    val isCustomVideo = sessionData.category == "customVideo"
    val noSpeechButNotCustom = !isCustomVideo && sessionData.speakingTime <= 0.0
    var showNames by remember { mutableStateOf(false) }
    var namesList = remember { mutableStateListOf<GetNamesByIdData>() }

    var isNamesLoading by remember { mutableStateOf(false) }
    var selectedName by remember { mutableStateOf<String?>(null) }

    val downloadAudio: () -> Unit = {
        if (isCustomVideo) {
        } else {
            val audioUrl = "${Res.Audio.audio_base_url}${sessionData.sessionId}"
            val downloadLink = document.createElement("a") as HTMLAnchorElement
            downloadLink.href = audioUrl
            downloadLink.download = "${sessionData.coachName}_${sessionData.sessionDateTime}.aac"
            document.body?.appendChild(downloadLink)
            downloadLink.click()
            document.body?.removeChild(downloadLink)
        }
    }

    fun playVideoWithAudio(
        videoElement: HTMLVideoElement,
        audioElement: Audio?,
    ) {
        val timeoutId: Int? = null
        var videoPlayPromise: Promise<Unit>? = null
        var audioPlayPromise: Promise<Unit>? = null


        if (!fullSessionVideo) return

        isVideoDurationPlaying1 = true
        isSeeking1 = true
        isBuffering1 = true
        videoProgress1 = 0f

        //  CASE: Use original video audio directly (no external audio)
        if (useOriginalAudio || audioElement == null) {
            videoElement.play().catch {
                debugPrintln(" Error playing video with original/custom audio: ${it.message}")
            }
            return
        }

        val safelyPauseMedia = {
            videoPlayPromise?.then {
                videoElement.pause()
                videoPlayPromise = null
            }?.catch {
                videoPlayPromise = null
            } ?: videoElement.pause()

            audioPlayPromise?.then {
                audioElement.pause()
                audioPlayPromise = null
            }?.catch {
                audioPlayPromise = null
            } ?: audioElement.pause()
        }

        val cleanup = {
            debugPrintln("Cleanup function called")
            safelyPauseMedia()

            isVideoDurationPlaying1 = false
            videoProgress1 = 0f
            audioProgress1 = 0f
            currentlyPlayingVideoId1 = null
            currentVideoRef1.value = null
            currentAudioRefHighlight1.value = null

            videoElement.onwaiting = null
            videoElement.onplaying = null
            videoElement.oncanplay = null
            videoElement.ontimeupdate = null
            videoElement.onprogress = null

            timeoutId?.let { window.clearTimeout(it) }
        }

        videoElement.onwaiting = {
            isBuffering1 = true
            debugPrintln("Video is buffering... Current time: ${videoElement.currentTime}")
            safelyPauseMedia()
        }

        videoElement.onplaying = {
            isBuffering1 = false
            debugPrintln(" on playing triggered at ${videoElement.currentTime}")

            if (!useOriginalAudio && audioElement.paused) {
                audioPlayPromise = audioElement.play()
                audioPlayPromise?.catch { error ->
                    debugPrintln("Error playing audio after video started: $error")
                }
            }
        }

        videoElement.onprogress = {
            if (videoElement.buffered.length > 0) {
                val bufferedEnd = videoElement.buffered.end(0)
                val bufferedSeconds = bufferedEnd - videoElement.currentTime

                if (bufferedSeconds > 10 && videoElement.paused) {
                    debugPrintln("Buffer sufficient, resuming playback.")
                    isBuffering1 = false

                    videoPlayPromise = videoElement.play()
                    videoPlayPromise?.then {
                        audioPlayPromise = audioElement.play()
                        audioPlayPromise?.catch { error ->
                            debugPrintln("Error playing audio after buffer: $error")
                        }
                    }?.catch { error ->
                        debugPrintln("Error playing video after buffer: $error")
                    }
                }
            }
        }

        videoElement.oncanplay = {
            debugPrintln("Video can play now at time: ${videoElement.currentTime}")
            isBuffering1 = false

            if (useOriginalAudio || isCustomVideo) {
                videoPlayPromise = videoElement.play()
                videoPlayPromise?.catch { error ->
                    debugPrintln("Error playing original/custom video: $error")
                    cleanup()
                }
            } else {
                videoPlayPromise = videoElement.play()
                videoPlayPromise?.then {
                    audioPlayPromise = audioElement.play()
                    audioPlayPromise?.then {
                        debugPrintln("Audio started playing successfully.")
                    }?.catch { error ->
                        debugPrintln("Error playing audio: $error")
                    }
                }?.catch { error ->
                    debugPrintln("Error playing video: $error")
                    cleanup()
                }
            }
        }

        videoElement.ontimeupdate = {
            if (!fullSessionVideo) {
                cleanup()
            }

            val currentTime = videoElement.currentTime
            currentVideoTime = currentTime
            debugPrintln("currentTime $currentTime")

            val timeDiff = kotlin.math.abs(currentTime - audioElement.currentTime)

            if (timeDiff > 0.2 && currentTime - Constants.lastSyncTime > 1.0) {
                Constants.lastSyncTime = currentTime
                try {
                    audioElement.pause()
                    audioElement.currentTime = currentTime
                    audioElement.play().catch {
                        console.log(" Audio play error after re-sync")
                    }
                } catch (e: dynamic) {
                    console.log(" Re-sync exception: ${e.message}")
                }
            }

            val videoDuration = videoElement.duration
            val audioDuration = audioElement.duration
            val maxDuration = maxOf(videoDuration, audioDuration)

            if (maxDuration > 0.0 && allowProgressUpdate && isVideoDurationPlaying1) {
                val newProgress =
                    (videoElement.currentTime / maxDuration).toFloat().coerceIn(0f, 1f)
                if (kotlin.math.abs(newProgress - videoProgress1) > 0.001f) {
                    videoProgress1 = newProgress
                }
            }
        }
    }

    LaunchedEffect(currentlyPlayingVideoId1, fullSessionVideo, currentKeywordSegmentIndex) {
        if (manualSeekTriggered) {
            debugPrintln("⏭️ Skipping auto-playback due to manual seek")
            return@LaunchedEffect
        }
        debugPrintln("Launched effect begin")
        val videoElement = currentVideoRef1.value
        val audioElement = currentAudioRefHighlight1.value

        // 🔒 Force original audio when custom video
        if (isCustomVideo && !useOriginalAudio) {
            useOriginalAudio = true
        }

        val safelyPauseMedia = {
            videoElement?.let { if (!it.paused && !it.ended) it.pause() }
            if (!useOriginalAudio && audioElement != null) {
                if (!audioElement.paused && !audioElement.ended) {
                    audioElement.pause()
                }
            }
        }

        // ⏳ Ensure metadata is loaded
        if (videoElement != null && videoElement.duration == 0.0) {
            suspend fun waitForVideoMetadata(video: HTMLVideoElement) {
                val metadataLoaded = CompletableDeferred<Unit>()
                video.onloadedmetadata = { metadataLoaded.complete(Unit) }
                video.load()
                metadataLoaded.await()
            }
            waitForVideoMetadata(videoElement)
        }

        if (!fullSessionVideo) {
            safelyPauseMedia()
            isVideoDurationPlaying1 = false
            currentlyPlayingVideoId1 = null
            currentVideoRef1.value = null
            currentAudioRefHighlight1.value = null
            videoProgress1 = 0f
            audioProgress1 = 0f
            currentSegmentTime = null
            return@LaunchedEffect
        }

        if (currentlyPlayingVideoId1 == sessionId1 && fullSessionVideo) {
            isVideoDurationPlaying1 = true

            val videoDuration = videoElement?.duration ?: 0.0
            val audioDuration = (sessionData.recordTime.toDoubleOrNull() ?: 0.0) / 1000.0
            val maxDuration = maxOf(videoDuration, audioDuration)

            allowProgressUpdate = false

            if ((selectedKeyword != null || selectedName != null) && highlightSegments.isNotEmpty()) {
                var i = currentKeywordSegmentIndex
                while (
                    i < highlightSegments.size &&
                    currentlyPlayingVideoId1 == sessionId1 &&
                    fullSessionVideo
                ) {
                    val (start, end) = highlightSegments[i]
                    currentSegmentTime = start.toString() to end.toString()

                    safelyPauseMedia()

                    val videoDuration1 = videoElement?.duration ?: 0.0
                    if (start >= videoDuration1) {
                        videoElement?.pause()
                        videoElement?.currentTime = videoDuration1
                        i++
                        currentKeywordSegmentIndex = i
                        continue
                    }

                    videoElement?.currentTime = start.toDouble().coerceAtMost(videoDuration1)
                    if (!useOriginalAudio && audioElement != null) {
                        audioElement.currentTime = start.toDouble()
                    }

                    if (useOriginalAudio || audioElement == null) {
                        videoElement?.play()?.catch {
                            debugPrintln(" Video play error (original audio): ${it.message}")
                        }
                    } else {
                        playVideoWithAudio(videoElement!!, audioElement)
                    }

                    while (
                        fullSessionVideo &&
                        ((useOriginalAudio && (videoElement?.currentTime ?: 0.0) < end) ||
                                (!useOriginalAudio && (audioElement?.currentTime ?: 0.0) < end)) &&
                        currentKeywordSegmentIndex == i
                    ) {
                        val currentTime = if (useOriginalAudio) videoElement?.currentTime ?: 0.0
                        else audioElement?.currentTime ?: 0.0

                        val clampedProgress = (currentTime / maxDuration).toFloat().coerceIn(0f, 1f)
                        if (kotlin.math.abs(clampedProgress - videoProgress1) > 0.005f) {
                            videoProgress1 = clampedProgress
                        }
                        delay(100)
                    }

                    safelyPauseMedia()

                    if (currentKeywordSegmentIndex == i) {
                        i++
                        currentKeywordSegmentIndex = i
                    } else {
                        break // user paginated → stop loop
                    }
                }
            } else if (selectedKeyword == null) {
                safelyPauseMedia()
                val seekTime = seekWhenPaused ?: 0.0

                val end = if (isCustomHighlight && sliderEndTime > sliderStartTime) {
                    sliderEndTime
                } else {
                    maxDuration
                }

                videoElement?.currentTime = seekTime
                if (!useOriginalAudio) {
                    audioElement?.currentTime = seekTime
                }
                seekWhenPaused = null

                if (useOriginalAudio || audioElement == null) {
                    videoElement?.play()?.catch { debugPrintln(" Video play error") }
                } else {
                    playVideoWithAudio(videoElement!!, audioElement)
                }

                while (
                    fullSessionVideo &&
                    ((useOriginalAudio && (videoElement?.currentTime ?: 0.0) < end) ||
                            (!useOriginalAudio && (audioElement?.currentTime ?: 0.0) < end))
                ) {
                    val current = if (useOriginalAudio) videoElement?.currentTime ?: 0.0
                    else audioElement?.currentTime ?: 0.0
                    val clampedProgress = (current / maxDuration).toFloat().coerceIn(0f, 1f)
                    if (kotlin.math.abs(clampedProgress - videoProgress1) > 0.005f) {
                        videoProgress1 = clampedProgress
                    }
                    delay(100)
                }

                safelyPauseMedia()
            }

            //  Reset after playback finishes
            allowProgressUpdate = true
            safelyPauseMedia()
            isVideoDurationPlaying1 = false
            fullSessionVideo = false
            stopPaginationSize = false
            currentlyPlayingVideoId1 = null
            currentVideoRef1.value = null
            currentAudioRefHighlight1.value = null
            videoProgress1 = 0f
            audioProgress1 = 0f
            currentSegmentTime = null
            currentKeywordSegmentIndex = 0
        }
    }


    //

//
    var uploadingSessionData by remember { mutableStateOf<GetSessionsData?>(null) }

    var uploadProgress by remember {
        mutableStateOf(
            UploadStateManager.getUploadProgress(
                sessionData1.sessionId
            )
        )
    }
    var uploadStatus by remember { mutableStateOf(UploadStateManager.getUploadStatus(sessionData1.sessionId)) }


    LaunchedEffect(sessionData1) {
        debugPrintln("assigned")
        sessionData = sessionData1
        uploadProgress = UploadStateManager.getUploadProgress(sessionData1.sessionId)
        uploadStatus = UploadStateManager.getUploadStatus(sessionData1.sessionId)

        // Register callback for this session
        UploadStateManager.setSessionUpdateCallback(sessionData1.sessionId) { fileName ->
            sessionData = sessionData.copy(videoFile = fileName)
            videoUrlFile(sessionData)
        }
    }

    LaunchedEffect(sessionData.sessionId) {
        try {
            val response = getNamesById(
                GetNamesByIdPayload(
                    organization = AppGlobal.userData.organization,
                    sessionId = sessionData.sessionId,
                    userId = "",
                    seasonId = AppGlobal.selectedSeasonId
                )
            )
            namesList.clear()
            namesList.addAll(response.data)
        } catch (e: Exception) {
            debugPrintln("Error loading names: ${e.message}")
            namesList.clear()
        }
    }

    val parts = sessionData.sessionId.removeSuffix(".aac").split("_")
    val sessionName = parts.first()
    when {
        noSpeechButNotCustom -> {
            Box(
                modifier = Modifier
                    .width(
                        if (breakpoint > Breakpoint.LG) 69.percent else if (breakpoint == Breakpoint.LG) 67.percent
                        else if (breakpoint > Breakpoint.MD) 49.percent else 100.percent
                    )
                    .margin(topBottom = if (breakpoint <= Breakpoint.MD) 10.px else 0.px)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .borderRadius(15.px)
                    .overflow(
                        overflowY = Overflow.Hidden,
                        overflowX = Overflow.Auto
                    )
                    .boxShadow(
                        offsetY = 1.px,
                        blurRadius = 3.px,
                        color = sitePalette.boxShadowColor.rgb
                    )
                    .padding(
                        leftRight = if (breakpoint >= Breakpoint.LG) 30.px else 20.px,
                        topBottom = if (breakpoint >= Breakpoint.LG) 20.px else 10.px
                    )
            ) {
                Column(
                    modifier = Modifier.width(100.percent)
                        .fillMaxHeight()
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        SectionTitle(sessionName.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() })
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .gap(if (breakpoint < Breakpoint.MD) 10.px else 36.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            FieldTitleTextNormalSimple(
                                text = "Coach:  ",
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                            FieldTitleTextNormalSimple(
                                text = sessionData.coachName,
                                fontWeight = 600,
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                        }

                        Row(
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(src = Res.Images.timeCircle, modifier = Modifier.size(17.px))
                            CustomSpacer(5.px)
                            FieldTitleTextNormalSimple(
                                text = "Duration:  ",
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                            FieldTitleTextNormalSimple(
                                text = "-",
                                fontWeight = 600,
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                        }
                        Row(
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(src = Res.Images.calender, modifier = Modifier.size(17.px))
                            CustomSpacer(5.px)
                            FieldTitleTextNormalSimple(
                                text = "Recorded:  ",
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                            FieldTitleTextNormalSimple(
                                text = "${sessionData.sessionDateTime.formatSessionDate()} ${sessionData.sessionDateTime.formatSessionHoursAmPm()}",
                                fontWeight = 600,
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                        }
                    }

                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .height(200.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "No data found for this session",
                            color = sitePalette.textFieldTextColor.rgb,
                            fontSize = 16.px,
                            textAlign = TextAlign.Center,
                            width = 100.percent
                        )
                    }
                }

            }
        }

        else -> {
//
            val getSentences = remember { mutableStateListOf<GetSentencesData>() }

            var uploadedVideoUrl by remember { mutableStateOf<String?>(null) }

            var isPlayingAll by remember { mutableStateOf(false) }
            var currentSentenceIndex by remember { mutableStateOf(0) }
            var players by remember { mutableStateOf<List<GetClubPlayerData>>(emptyList()) }
            var coaches by remember { mutableStateOf<List<GetClubCoachesData>>(emptyList()) }
            var isLoading by remember { mutableStateOf(true) }
            var isEmotionLoading by remember { mutableStateOf(true) }
            var isSentenceLoading by remember { mutableStateOf(true) }
            var error by remember { mutableStateOf<String?>(null) }
//
            var isPlayingAllHighlight by remember { mutableStateOf(false) }
            var currentlyPlayingIdHighlight by remember { mutableStateOf<String?>(null) }

            var currentlyPlayingIdFullSession by remember { mutableStateOf<String?>(null) }
            var loadingSessionIdFullSession by remember { mutableStateOf<String?>(null) }
            val currentAudioRefFullSession = remember { mutableStateOf<Audio?>(null) }
            val fullPlaySessionId = sessionData.sessionId

            val audioUrl = if (!isCustomVideo && sessionData.sessionId.isNotBlank()) {
                debugPrintln("✅ Will load audio from: ${Res.Audio.audio_base_url}${sessionData.sessionId}")
                "${Res.Audio.audio_base_url}${sessionData.sessionId}"
            } else {
                null
            }

            val fullAudio = remember(audioUrl) { audioUrl?.let { AudioManager.prepare(it) } }
            val getSentenceAudio = remember(audioUrl) { audioUrl?.let { AudioManager.prepare(it) } }
            val playAllAudio = remember(audioUrl) { audioUrl?.let { AudioManager.prepare(it) } }


            var fullPlayAudioProgress by remember { mutableStateOf(0f) }
            var isPlayingAllSegments by remember { mutableStateOf(false) }
            var hasVideoBecomeReady by remember(sessionData.sessionId) { mutableStateOf(false) }
            var hasClosedCustomHighlight by remember { mutableStateOf(false) }

            debugPrintln("sessionId11: ${sessionData.sessionId}")
            LaunchedEffect(sessionData.sessionId) {
                val videoElement =
                    document.getElementById("video_${sessionData.sessionId}") as? HTMLVideoElement
                hasVideoBecomeReady = false

                videoElement?.let { video ->
                    if (video.readyState >= 1) {
                        hasVideoBecomeReady = true
                    } else {
                        val metadataLoaded = CompletableDeferred<Unit>()
                        video.onloadedmetadata = {
                            hasVideoBecomeReady = true
                            metadataLoaded.complete(Unit)
                        }
                        video.load()
                        metadataLoaded.await()
                    }
                }
            }
            LaunchedEffect(selectedName) {
                fullSessionVideo = false
                isVideoDurationPlaying1 = false
                isAudioDurationPlaying = false
                isPlayingAll = false
                stopPaginationSize = false
                currentlyPlayingIdFullSession = null
                currentlyPlayingVideoId1 = null

                if (selectedName != null && getSentences.isNotEmpty()) {
                    val audioDuration = (sessionData.recordTime.toDoubleOrNull() ?: 0.0) / 1000.0

                    val segments = getSentences
                        .filter { sentenceItem: GetSentencesData ->
                            sentenceItem.keywords?.any {
                                it.text.equals(selectedName, ignoreCase = true)
                            } == true || sentenceItem.names?.any {
                                it.text.equals(selectedName, ignoreCase = true)
                            } == true
                        }
                        .map { sentenceItem: GetSentencesData ->
                            val rawStart = sentenceItem.startTime.toFloat()
                            val rawEnd = sentenceItem.endTime.toFloat()
                            val safeStart = (rawStart - Config.adjustTime).coerceAtLeast(0f)
                            val safeEnd =
                                (rawEnd + Config.adjustTime).coerceAtMost(audioDuration.toFloat())
                            safeStart to safeEnd
                        }
                        .sortedBy { it.first }

                    highlightSegments = segments

                    // Reset to first segment
                    currentKeywordSegmentIndex = 0
                    currentSentenceIndex = 0  // Also reset sentence index

                    if (segments.isNotEmpty()) {
                        currentSegmentTime =
                            segments[0].first.toString() to segments[0].second.toString()
                    } else {
                        currentSegmentTime = null
                    }

                } else if (selectedName == null && !showNames) {
                    // Reset when name is deselected
                    val segments = getSentences
                        .filter { sentenceItem: GetSentencesData ->
                            sentenceItem.keywords?.isNotEmpty() == true
                        }
                        .map { sentenceItem: GetSentencesData ->
                            sentenceItem.startTime.toFloat() to sentenceItem.endTime.toFloat()
                        }
                        .sortedBy { it.first }

                    highlightSegments = segments
                    currentKeywordSegmentIndex = 0
                    currentSentenceIndex = 0
                    currentSegmentTime = null
                }
            }

//

            var playJob: Job? = null
            fun cleanupAllMedia() {
                // Stop all video playback
                fullSessionVideo = false
                stopPaginationSize = false
                isVideoDurationPlaying1 = false
                currentlyPlayingVideoId1 = null
                currentVideoRef1.value?.pause()
                currentVideoRef1.value = null
                videoProgress1 = 0f

                // Stop all audio playback
                currentlyPlayingIdFullSession = null
                currentlyPlayingIdHighlight = null
                isPlayingAll = false
                isPlayingAllHighlight = false
                currentAudioRefHighlight1.value?.pause()
                currentAudioRefHighlight1.value = null
                currentAudioRefFullSession.value?.pause()
                currentAudioRefFullSession.value = null
                audioProgress1 = 0f
                fullPlayAudioProgress = 0f

                // Reset keyword selection
                selectedKeyword = null
                highlightSegments = emptyList()

                // Cancel any ongoing job
                playJob?.cancel()
                playJob = null
            }


            fun refreshHighlightSegmentsAfterVideoReady() {
                highlightSegments = getSentences
                    .filter { sentence ->
                        selectedKeyword?.let { keyword ->
                            sentence.keywords?.any {
                                it.text.equals(
                                    keyword,
                                    ignoreCase = true
                                )
                            } == true
                        } ?: !sentence.keywords.isNullOrEmpty() // 🛑 Only valid if it has keywords
                    }
                    .map { sentence -> sentence.startTime.toFloat() to sentence.endTime.toFloat() }
                    .distinct() // 💡 Optional: remove duplicates
                    .sortedBy { it.first }

            }

            suspend fun getVideoDurationMillis(file: File): Long =
                suspendCancellableCoroutine { cont ->
                    val videoElement = document.createElement("video") as HTMLVideoElement
                    val objectUrl = URL.createObjectURL(file)

                    videoElement.src = objectUrl
                    videoElement.preload = "metadata"

                    videoElement.onloadedmetadata = {
                        URL.revokeObjectURL(objectUrl)
                        val durationInMillis = (videoElement.duration * 1000).toLong()
                        cont.resume(durationInMillis) {}
                    }

                    videoElement.onerror = { _, _, _, _, _ ->
                        URL.revokeObjectURL(objectUrl)
                        cont.resumeWithException(Exception("Failed to load video metadata"))
                    }
                }


            val uploadFile: (File) -> Unit = { file ->
                val uploadingSessionId = sessionData.sessionId
                uploadingSessionData = sessionData

                UploadStateManager.setUploadState(uploadingSessionId, 0.0, "Initializing upload...")
                uploadProgress = 0.0
                uploadStatus = "Initializing upload..."

                scope.launch {
                    try {
                        val chunkSize = 4 * 1024 * 1024 // 4MB
                        val totalChunks = ceil(file.size.toDouble() / chunkSize).toInt()
                        val extension = file.name.substringAfterLast('.', "mp4")
                        val videoId = "video_${getCurrentMilliseconds()}.$extension"
                        val chunkIds = mutableListOf<String>()

                        UploadStateManager.setUploadState(
                            uploadingSessionId,
                            0.0,
                            "Uploading file in $totalChunks chunks..."
                        )
                        if (sessionData.sessionId == uploadingSessionId) {
                            uploadStatus = "Uploading file in $totalChunks chunks..."
                        }

                        for (chunkIndex in 0 until totalChunks) {
                            val start = chunkIndex * chunkSize
                            val end = minOf(start + chunkSize, file.size.toInt())
                            val chunk = file.slice(start, end)
                            val chunkId = chunkIndex.toString().padStart(6, '0')
                            chunkIds.add(chunkId)

                            val formData = FormData().apply {
                                append("file", chunk, file.name)
                                append("chunk_id", chunkId)
                                append("video_id", videoId)
                            }

                            val xhr = XMLHttpRequest()
                            xhr.open(Strings.POST, APIEndPoints.Name.upload_chunks, true)

                            xhr.upload.onprogress = { event ->
                                if (event.lengthComputable) {
                                    val progress = ((chunkIndex.toDouble() / totalChunks) * 100) +
                                            ((event.loaded.toDouble() / event.total.toDouble()) * (100.0 / totalChunks))
                                    UploadStateManager.setUploadState(
                                        uploadingSessionId,
                                        progress,
                                        uploadStatus
                                    )
                                    if (sessionData.sessionId == uploadingSessionId) {
                                        uploadProgress = progress
                                    }
                                }
                            }

                            val chunkCompleted = CompletableDeferred<Boolean>()
                            xhr.onload = {
                                if (xhr.status.toInt() == 200) {
                                    chunkCompleted.complete(true)
                                } else {
                                    val errorStatus = "Error uploading chunk $chunkId"
                                    UploadStateManager.setUploadState(
                                        uploadingSessionId,
                                        -1.0,
                                        errorStatus
                                    )
                                    if (sessionData.sessionId == uploadingSessionId) {
                                        uploadStatus = errorStatus
                                        uploadProgress = -1.0
                                    }
                                    chunkCompleted.completeExceptionally(Exception("Upload failed!"))
                                }
                            }
                            xhr.onerror = {
                                chunkCompleted.completeExceptionally(Exception("Upload error!"))
                            }

                            xhr.send(formData)
                            chunkCompleted.await()
                        }
                        val durationMillis = getVideoDurationMillis(file)
                        val commitFormData = FormData().apply {
                            append("video_id", videoId)
                            chunkIds.forEach { append("chunk_ids", it) }
                            append("sessionID", uploadingSessionId)
                            if (isCustomVideo) {
                                append("recordTime", durationMillis.toString())
                            }
                            append("organization", AppGlobal.userData.organization)
                            append("playerVideo", "false")
                        }

                        val commitResponse = window.fetch(
                            APIEndPoints.Name.commit_chunks,
                            RequestInit(
                                method = Strings.POST,
                                body = commitFormData
                            )
                        ).await().json().await()

                        val statusField = commitResponse.asDynamic().status as String?
                        val videoUrl = commitResponse.asDynamic().video_id as String?

                        if (statusField == "upload complete") {
                            UploadStateManager.setUploadState(
                                uploadingSessionId,
                                101.0,
                                "Upload complete!"
                            )
                            if (sessionData.sessionId == uploadingSessionId) {
                                uploadStatus = "Upload complete!"
                                uploadProgress = 101.0
                            }
                            message("Video uploaded successfully!")
                            showToast("toastSuccess")
                            debugPrintln("videoUrl: $videoUrl")
                            scope.launch {
                                try {
                                    val res = getSingleCoach(
                                        organization = AppGlobal.userData.organization,
                                        domainType = "soccer",
                                        language = "en",
                                        sessionType = sessionType.name,
                                        userID = userId,
                                        seasonID = AppGlobal.selectedSeasonId
                                    )
                                    updateCoachInfo(res.data)

                                } catch (_: Exception) {
                                    debugPrintln("Exception")

                                }
                            }
                            uploadingSessionData?.let { originalSession ->
                                if (originalSession.sessionId == uploadingSessionId) {
                                    val videoDurationMillis = getVideoDurationMillis(file)
                                    val updatedSession = originalSession.copy(
                                        videoFile = "$videoUrl",
                                        recordTime = if (isCustomVideo) videoDurationMillis.toString() else originalSession.recordTime
                                    )

                                    videoUrlFile(updatedSession)

                                    if (sessionData.sessionId == originalSession.sessionId) {
                                        sessionData = updatedSession
                                    }
                                }
                            }

                            uploadingSessionData = null
                        } else {
                            UploadStateManager.setUploadState(
                                uploadingSessionId,
                                -1.0,
                                "Upload failed!"
                            )
                            if (sessionData.sessionId == uploadingSessionId) {
                                uploadStatus = "Upload failed!"
                                uploadProgress = -1.0
                            }
                            message("Video uploading error!")
                            showToast("toastError")
                        }
                    } catch (e: Exception) {
                        e.printStackTrace()
                        UploadStateManager.setUploadState(
                            uploadingSessionId,
                            -1.0,
                            "Error: ${e.message}"
                        )
                        if (sessionData.sessionId == uploadingSessionId) {
                            uploadStatus = "Error: ${e.message}"
                            uploadProgress = -1.0
                        }
                        message("Video uploading error!")
                        showToast("toastError")
                    }
                }
            }


            val uniqueKeywords = mutableMapOf<String, Pair<Int, String>>()
            getSentences.forEach { sentence ->
                val sentenceKeywords = sentence.keywords ?: emptyList()
                val distinctKeywords =
                    sentenceKeywords.map { it.text.lowercase() to it.keywordCategory }.toSet()

                for ((keyword, category) in distinctKeywords) {
                    val (currentCount, _) = uniqueKeywords[keyword] ?: (0 to category)
                    uniqueKeywords[keyword] = (currentCount + 1) to category
                }
            }
            val keywordSegmentsMap = getSentences.flatMap { sentence ->
                val keywordTexts =
                    sentence.keywords?.map { it.text.trim().lowercase() } ?: emptyList()
                keywordTexts.map { keyword ->
                    keyword to (sentence.startTime to sentence.endTime)
                }
            }.groupBy({ it.first }, { it.second })


            val filteredKeywords = sessionKeywords
                .filter { keywordItem ->
                    keywordSegmentsMap.containsKey(keywordItem.text.trim().lowercase())
                }
                .sortedByDescending { it.usageCount }



            DisposableEffect(Unit) {
                onDispose {
                    cleanupAllMedia()
                    if (currentlyPlayingIdFullSession == sessionData.sessionId) {
                        fullAudio?.pause()
                        currentlyPlayingIdFullSession = null
                        fullPlayAudioProgress = 0f
                    }
                }
            }

            LaunchedEffect(getSentences) {
                if (selectedKeyword == null) {
                    val allSegments = getSentences.flatMap { sentence ->
                        sentence.keywords?.map { _ ->
                            val start = sentence.startTime.toFloat()
                            val end = sentence.endTime.toFloat()
                            start to end
                        } ?: emptyList()
                    }.sortedBy { it.first }

                    highlightSegments = allSegments
                }
            }

//
            //  Keyword-based playback
            LaunchedEffect(currentlyPlayingIdFullSession, currentKeywordSegmentIndex) {
                debugPrintln(" Starting keyword-based playback for session: ${sessionData.sessionId}")
                val video = currentVideoRef1.value
                val audio = currentAudioRefFullSession.value

                if (currentlyPlayingIdFullSession == sessionData.sessionId &&
                    audio != null &&
                    highlightSegments.isNotEmpty() &&
                    (selectedKeyword != null || selectedName != null)
                ) {
                    isAudioDurationPlaying = true
                    stopPaginationSize = true

                    var i = currentKeywordSegmentIndex
                    while (i < highlightSegments.size &&
                        currentlyPlayingIdFullSession == sessionData.sessionId
                    ) {
                        val (rawStart, rawEnd) = highlightSegments[i]
                        val start = rawStart.toDouble()
                        val end = rawEnd.toDouble()

                        debugPrintln("⏩ Segment $i: Should play from $start to $end")
                        currentSegmentTime = start.toString() to end.toString()

                        audio.pause()
                        if (audio.readyState >= 1) {
                            audio.currentTime = start
                            audio.play().catch { debugPrintln(" Audio play error: ${it.message}") }
                        } else {
                            audio.onloadedmetadata = {
                                audio.currentTime = start
                                audio.play()
                                    .catch { debugPrintln(" Audio play error after metadata: ${it.message}") }
                            }
                        }

                        val segmentDuration = end - start
                        while (
                            audio.currentTime < end &&
                            currentlyPlayingIdFullSession == sessionData.sessionId &&
                            currentKeywordSegmentIndex == i
                        ) {
                            val now = audio.currentTime
                            val elapsed = (now - start).coerceAtLeast(0.0)
                            fullPlayAudioProgress =
                                (elapsed / segmentDuration).toFloat().coerceIn(0f, 1f)
                            delay(100)
                        }

                        audio.pause()

                        if (currentKeywordSegmentIndex == i) {
                            i++
                            currentKeywordSegmentIndex = i
                        } else {
                            break
                        }
                    }


                    isAudioDurationPlaying = false
                    stopPaginationSize = false
                    currentlyPlayingIdFullSession = null
                    currentSegmentTime = null
                    fullPlayAudioProgress = 0f
                    currentKeywordSegmentIndex = 0
                }
            }

//  Fallback / custom highlight playback
            LaunchedEffect(currentlyPlayingIdFullSession, currentKeywordSegmentIndex) {
                if (currentlyPlayingIdFullSession == sessionData.sessionId) {
                    val audio = currentAudioRefFullSession.value ?: return@LaunchedEffect
                    isAudioDurationPlaying = true
                    stopPaginationSize = true

                    if ((selectedKeyword != null || selectedName != null) && highlightSegments.isNotEmpty()) {
                        var i = currentKeywordSegmentIndex
                        while (i < highlightSegments.size &&
                            currentlyPlayingIdFullSession == sessionData.sessionId
                        ) {
                            val (rawStart, rawEnd) = highlightSegments[i]
                            val start = rawStart.toDouble()
                            val end = rawEnd.toDouble()

                            debugPrintln("⏩ Segment $i: Should play from $start to $end")
                            currentSegmentTime = start.toString() to end.toString()

                            audio.pause()
                            if (audio.readyState >= 1) {
                                audio.currentTime = start
                                audio.play()
                                    .catch { debugPrintln(" Audio play error: ${it.message}") }
                            } else {
                                audio.onloadedmetadata = {
                                    audio.currentTime = start
                                    audio.play()
                                        .catch { debugPrintln(" Audio play error after metadata: ${it.message}") }
                                }
                            }

                            val segmentDuration = end - start
                            while (
                                audio.currentTime < end &&
                                currentlyPlayingIdFullSession == sessionData.sessionId &&
                                currentKeywordSegmentIndex == i
                            ) {
                                val now = audio.currentTime
                                val elapsed = (now - start).coerceAtLeast(0.0)
                                fullPlayAudioProgress =
                                    (elapsed / segmentDuration).toFloat().coerceIn(0f, 1f)
                                delay(100)
                            }

                            audio.pause()

                            if (currentKeywordSegmentIndex == i) {
                                i++
                                currentKeywordSegmentIndex = i
                            } else {
                                break
                            }
                        }

                        currentlyPlayingIdFullSession = null
                        fullPlayAudioProgress = 0f
                        currentKeywordSegmentIndex = 0
                    } else if (selectedKeyword == null) {
                        val start = if (isCustomHighlight && sliderEndTime > sliderStartTime) {
                            sliderStartTime
                        } else 0.0

                        val end = if (isCustomHighlight && sliderEndTime > sliderStartTime) {
                            sliderEndTime
                        } else audio.duration

                        audio.currentTime = start
                        if (audio.paused) {
                            audio.play().catch {
                                debugPrintln(" Audio play error during custom range: ${it.message}")
                            }
                        }

                        while (audio.currentTime < end && currentlyPlayingIdFullSession == sessionData.sessionId) {
                            val progressInSegment =
                                ((audio.currentTime - start) / (end - start)).toFloat()
                                    .coerceIn(0f, 1f)
                            fullPlayAudioProgress = progressInSegment
                            delay(100)
                        }

                        audio.pause()
                        isAudioDurationPlaying = false
                        stopPaginationSize = false

                        currentlyPlayingIdFullSession = null
                        fullPlayAudioProgress = 0f
                    }
                }
            }


            //    pause audio vid
            LaunchedEffect(isCustomHighlight, hasClosedCustomHighlight) {
                isAudioDurationPlaying = false
                stopPaginationSize = false
                isVideoDurationPlaying1 = false
                currentVideoRef1.value?.pause()
                currentAudioRefHighlight1.value?.pause()
                currentlyPlayingIdFullSession = null
                currentAudioRefFullSession.value?.pause()
            }


            LaunchedEffect(sessionData.sessionId) {
                cleanupAllMedia()
                debugPrintln("Session changed to: ${sessionData.sessionId}")
                if (currentlyPlayingIdFullSession != sessionData.sessionId) {
                    debugPrintln("Stopping previous audio because sessionId changed.")

                    // Pause and reset any playing audio
                    currentAudioRefFullSession.value?.pause()
                    fullAudio?.pause()
                    getSentenceAudio?.pause()
                    playAllAudio?.pause()

                    // Reset all states related to playing audio

                    currentlyPlayingIdFullSession = null
                    currentlyPlayingIdHighlight = null
                    isPlayingAll = false
                    fullPlayAudioProgress = 0f
                    currentSegmentTime = null
                    seekTimeForHighlight = null
                    currentSentenceIndex = 0
                    sliderStartTime = 0.0
                    sliderEndTime = 0.0
                    useOriginalAudio = false
                    isCustomHighlight = false
                    currentVideoTime = 0.0
                    playAllHide = false

                    // ✅ Reset names-related state
                    showNames = false
                    selectedName = null
                    selectedKeyword = null
                    currentKeywordSegmentIndex = 0

                    // ✅ Reset highlight segments
                    highlightSegments = emptyList()


                }
            }


            LaunchedEffect(selectedKeyword) {
                fullSessionVideo = false
                stopPaginationSize = false
                isVideoDurationPlaying1 = false
                currentlyPlayingIdFullSession = null
                currentlyPlayingVideoId1 = null
                seekWhenPaused = null
                secondSeekbar = false
                isAudioDurationPlaying = false
                isPlayingAll = false
                selectedName = null
                // Pause everything
                val safelyPauseAudio =
                    { audio: Audio? -> audio?.takeIf { !it.paused && !it.ended }?.pause() }
                val safelyPauseVideo = { video: HTMLVideoElement? ->
                    video?.takeIf { !it.paused && !it.ended }?.pause()
                }

                safelyPauseAudio(currentAudioRefHighlight1.value)
                safelyPauseVideo(currentVideoRef1.value)
                safelyPauseAudio(currentAudioRefFullSession.value)

                videoProgress1 = 0f
                audioProgress1 = 0f
                fullPlayAudioProgress = 0f

                val videoElement = document.getElementById("video_$sessionId1") as? HTMLVideoElement
                val videoDuration = videoElement?.duration ?: 0.0
                val audioDuration = (sessionData.recordTime.toDoubleOrNull() ?: 0.0) / 1000.0
                val maxDuration = maxOf(videoDuration, audioDuration)

                debugPrintln("🟡 Selected keyword changed: $selectedKeyword")
                debugPrintln("Video Duration: $videoDuration")
                debugPrintln("Audio Duration from recordTime: $audioDuration")
                debugPrintln("Using Max Duration: $maxDuration")

                if (selectedKeyword != null) {


                    val segments = getSentences.filter { sentence ->
                        sentence.keywords?.any {
                            it.text.equals(selectedKeyword, ignoreCase = true)
                        } == true
                    }.map { sentence ->
                        val rawStart = sentence.startTime.toFloat()
                        val rawEnd = sentence.endTime.toFloat()

                        val safeStart = (rawStart - Config.adjustTime).coerceAtLeast(0f)
                        val safeEnd =
                            (rawEnd + Config.adjustTime).coerceAtMost(audioDuration.toFloat())

                        safeStart to safeEnd
                    }.sortedBy { it.first }


                    highlightSegments = segments
                    currentSegmentTime = segments.firstOrNull()?.let {
                        it.first.toString() to it.second.toString()
                    }
                } else {
                    // 🔵 When page loads or keyword unselected
                    val segments = getSentences.filter { sentence ->
                        !sentence.keywords.isNullOrEmpty()
                    }.map { sentence ->
                        sentence.startTime.toFloat() to sentence.endTime.toFloat()
                    }.sortedBy { it.first }

                    highlightSegments = segments
                    currentSegmentTime = null
                    currentVideoTime = 0.0
                }

                // Load video metadata
                videoElement?.let {
                    if (it.readyState < 1) it.load()
                }
            }

            // When switching between Names and Keywords tabs
            LaunchedEffect(showNames) {
                if (getSentences.isNotEmpty()) {
                    if (showNames && selectedName == null) {
                        // Switched to Names tab - show all name locations
                        debugPrintln("🟡 Switched to Names tab - showing all name locations")
                        val audioDuration =
                            (sessionData.recordTime.toDoubleOrNull() ?: 0.0) / 1000.0

                        val segments = getSentences
                            .filter { sentenceItem: GetSentencesData ->
                                sentenceItem.names?.isNotEmpty() == true
                            }
                            .map { sentenceItem: GetSentencesData ->
                                val rawStart = sentenceItem.startTime.toFloat()
                                val rawEnd = sentenceItem.endTime.toFloat()
                                val safeStart = (rawStart - Config.adjustTime).coerceAtLeast(0f)
                                val safeEnd =
                                    (rawEnd + Config.adjustTime).coerceAtMost(audioDuration.toFloat())
                                safeStart to safeEnd
                            }
                            .sortedBy { it.first }

                        highlightSegments = segments
                        debugPrintln("✅ Total highlight segments for Names tab: ${segments.size}")

                        // Reset indices
                        currentKeywordSegmentIndex = 0
                        currentSentenceIndex = 0
                        if (segments.isNotEmpty()) {
                            currentSegmentTime =
                                segments[0].first.toString() to segments[0].second.toString()
                        } else {
                            currentSegmentTime = null
                        }
                    } else if (!showNames && selectedKeyword == null && selectedName == null) {
                        // Switched back to Keywords tab - show all keyword locations
                        debugPrintln("🟡 Switched to Keywords tab - showing all keyword locations")
                        val audioDuration =
                            (sessionData.recordTime.toDoubleOrNull() ?: 0.0) / 1000.0

                        val segments = getSentences
                            .filter { sentenceItem: GetSentencesData ->
                                sentenceItem.keywords?.isNotEmpty() == true
                            }
                            .map { sentenceItem: GetSentencesData ->
                                val rawStart = sentenceItem.startTime.toFloat()
                                val rawEnd = sentenceItem.endTime.toFloat()
                                val safeStart = (rawStart - Config.adjustTime).coerceAtLeast(0f)
                                val safeEnd =
                                    (rawEnd + Config.adjustTime).coerceAtMost(audioDuration.toFloat())
                                safeStart to safeEnd
                            }
                            .sortedBy { it.first }

                        highlightSegments = segments
                        debugPrintln("✅ Total highlight segments for Keywords tab: ${segments.size}")

                        // Reset indices
                        currentKeywordSegmentIndex = 0
                        currentSentenceIndex = 0
                        if (segments.isNotEmpty()) {
                            currentSegmentTime =
                                segments[0].first.toString() to segments[0].second.toString()
                        } else {
                            currentSegmentTime = null
                        }
                    }
                }
            }
            // Ensure this is only triggered once during composition
            LaunchedEffect(Unit) {
                try {
                    isLoading = true
                    error = null
                    val response = getClubCoaches(
                        organization = AppGlobal.userData.organization,
                        domainType = "soccer",
                        language = "en",
                        sessionType = sessionType.toString(),
                        seasonID = AppGlobal.selectedSeasonId
                    )
                    coaches = response.data

                } catch (e: Exception) {
                    error = "Failed to load players: ${e.message}"
                    debugPrintln("Error loading players: ${e.message}")
                } finally {
                    isLoading = false
                }


            }
            LaunchedEffect(teamIds){
                try {
                    isLoading = true
                    error = null
                    val response = getClubPlayer(
                        organization = AppGlobal.userData.organization,
                        team =teamIds ,
                    )
                    players = response.data

                } catch (e: Exception) {
                    error = "Failed to load players: ${e.message}"
                    debugPrintln("Error loading players: ${e.message}")
                } finally {
                    isLoading = false
                }
            }

            LaunchedEffect(sessionData.sessionId) {
                isEmotionLoading = true
                try {
                    val keywordsResponse = getSessionKeywords(
                        organization = AppGlobal.userData.organization,
                        sessionId = sessionData.sessionId,
                        userID = ""
                    )
                    val sortedKeyword = keywordsResponse.data.sortedByDescending { it.usageCount }
                    sessionKeywords.clear()
                    sessionKeywords.addAll(sortedKeyword)
                } catch (e: Exception) {
                    // Optional: handle error
                }
                isEmotionLoading = false
            }


// Only re-fetch sentences when `sessionData.sessionId` changes
            LaunchedEffect(sessionData.sessionId) {
                try {

                    isSentenceLoading = true
                    val getSentencesResponse = getSentences(
                        sessionID = sessionData.sessionId,
                        type = "sentence",
                        organization = AppGlobal.userData.organization
                    )
                    getSentences.clear()
                    getSentences.addAll(getSentencesResponse.data)

                } catch (e: Exception) {
                    debugPrintln("Error loading sentences: ${e.message}")
                } finally {
                    isSentenceLoading = false
                }

            }


            // In your existing LaunchedEffect for initializing highlights
            LaunchedEffect(getSentences.size) {
                val videoElement = document.getElementById("video_$sessionId1") as? HTMLVideoElement
                val isVideoReady = (videoElement?.readyState ?: 0) >= 1

                if (selectedKeyword == null && selectedName == null && getSentences.isNotEmpty()) {
                    if (isVideoReady || sessionData.videoFile.isEmpty()) {
                        highlightSegments = getSentences
                            .filter {
                                it.keywords?.isNotEmpty() == true || it.names?.isNotEmpty() == true
                            }
                            .map {
                                it.startTime.toFloat() to it.endTime.toFloat()
                            }
                            .sortedBy { it.first }

                        debugPrintln("✅ highlightSegments initialized with ${highlightSegments.size} segments")
                    }
                }
            }



            var playAllJob: Job? = null
            var isAudioLoading by remember { mutableStateOf(false) }

            fun stopAudioAndReset(audioElement: Audio) {
                audioElement.pause()
                audioElement.currentTime = 0.0
                selectedKeyword = null
                currentKeywordSegmentIndex = 0
                playAllJob = null
                isAudioLoading = false
                isPlayingAllSegments = false
                debugPrintln("Stopping play all")
            }
            fun playAllSentencesSequentially(
                sentences: List<GetSentencesData>,
                audioElement: Audio?,
                videoElement: HTMLVideoElement?,
                onPlaybackFinished: () -> Unit,
            ) {
                playAllJob?.cancel()

                playAllJob = CoroutineScope(Dispatchers.Main).launch {
                    isPlayingAllSegments = true

                    // 🟢 ADD NAMES LOGIC HERE - Filter sentences based on selectedName or selectedKeyword
                    val sentencesWithKeywords = if (selectedName != null) {
                        // Filter by selected name
                        sentences.filter { sentence ->
                            sentence.keywords?.any { it.text.equals(selectedName, ignoreCase = true) } == true ||
                                    sentence.names?.any { it.text.equals(selectedName, ignoreCase = true) } == true
                        }.sortedByDescending { (it.keywords?.size ?: 0) + (it.names?.size ?: 0) }
                    } else if (selectedKeyword != null) {
                        // Filter by selected keyword
                        sentences.filter { sentence ->
                            sentence.keywords?.any { it.text.equals(selectedKeyword, ignoreCase = true) } == true
                        }.sortedByDescending { it.keywords?.size ?: 0 }
                    } else if (showNames) {
                        // On Names tab without specific name selected - play all name sentences
                        sentences.filter { sentence ->
                            sentence.names?.isNotEmpty() == true
                        }.sortedByDescending { it.names?.size ?: 0 }
                    } else {
                        // On Keywords tab without specific keyword selected - play all keyword sentences
                        sentences.filter { sentence ->
                            sentence.keywords?.isNotEmpty() == true
                        }.sortedByDescending { it.keywords?.size ?: 0 }
                    }

                    var i = 0  // start from first page

                    while (i < sentencesWithKeywords.size) {
                        if (!isPlayingAll) {
                            break
                        }

                        val sentence = sentencesWithKeywords[i]

                        val adjustedStart =
                            (sentence.startTime - Config.adjustTime).coerceAtLeast(0.0)
                        val adjustedEnd = (sentence.endTime + Config.adjustTime)
                            .coerceAtMost(audioElement?.duration ?: Double.MAX_VALUE)


                        currentSentenceIndex = i        // drives UI sentence card
                        currentKeywordSegmentIndex = i  // drives waveform
                        currentSegmentTime = adjustedStart.toString() to adjustedEnd.toString()
                        isAudioLoading = true

                        try {
                            videoElement?.pause()
                            audioElement?.pause()
                            videoElement?.currentTime = adjustedStart
                                .coerceAtMost(videoElement?.duration ?: 0.0)
                            if (!useOriginalAudio && audioElement != null) {
                                audioElement.currentTime = adjustedStart
                            }
                        } catch (e: Exception) {
                            debugPrintln(" Seek error: ${e.message}")
                        }

                        val videoPromise = videoElement?.play()
                        videoPromise?.then {
                            if (!useOriginalAudio && audioElement != null) {
                                audioElement.play().then {
                                    debugPrintln("   ✅ Audio playing at ${audioElement.currentTime}")
                                    isAudioLoading = false
                                }.catch { err ->
                                    debugPrintln("    Audio play error: ${err.message}")
                                    isAudioLoading = false
                                }
                            } else {
                                isAudioLoading = false
                            }
                        }?.catch { err ->
                            isAudioLoading = false
                        }

                        if (videoPromise == null && !useOriginalAudio && audioElement != null) {
                            audioElement.play().then {
                                isAudioLoading = false
                            }.catch { err ->
                                isAudioLoading = false
                            }
                        }

                        val maxDuration =
                            maxOf(videoElement?.duration ?: 0.0, audioElement?.duration ?: 0.0)
                                .takeIf { it > 0.0 } ?: 1.0

                        var loopCount = 0
                        while (
                            isPlayingAll &&
                            currentSentenceIndex == i &&  // ← if user paginated, this breaks
                            (
                                    (!useOriginalAudio && (audioElement?.currentTime
                                        ?: 0.0) < adjustedEnd) ||
                                            (useOriginalAudio && (videoElement?.currentTime
                                                ?: 0.0) < adjustedEnd)
                                    )
                        ) {
                            val currentTime = if (useOriginalAudio) videoElement?.currentTime ?: 0.0
                            else audioElement?.currentTime ?: 0.0

                            loopCount++
                            fullPlayAudioProgress =
                                (currentTime / (audioElement?.duration ?: 1.0)).toFloat()
                            videoProgress1 = (currentTime / maxDuration).toFloat()
                            delay(100)
                        }

                        videoElement?.pause()
                        audioElement?.pause()

                        val finalTime = if (useOriginalAudio) videoElement?.currentTime ?: 0.0
                        else audioElement?.currentTime ?: 0.0

                        if (currentSentenceIndex != i) {
                            // user paginated → jump to wherever they navigated
                            i = currentSentenceIndex
                        } else {
                            // natural finish → move to next
                            i++
                            if (i < sentencesWithKeywords.size) {
                                currentSentenceIndex = i  // ← only update if still in bounds
                            }
                        }
                    }


                    // Reset
                    currentSegmentTime = null
                    currentKeywordSegmentIndex = -1
                    currentSentenceIndex = 0
                    playAllJob = null
                    isAudioLoading = false
                    isPlayingAllSegments = false
                    videoProgress1 = 0f
                    fullPlayAudioProgress = 0f
                    onPlaybackFinished()
                }
            }

            val widgetRenderers = rememberWidgetRenderers(
                widgetData = sessionData.widgetMetrics?.toClubAverages(),
                recentTrend = null,
                showSelection = false,
                sessionBorder = true,
                forceFullWidth = true,
                selectedIds = selectedWidgetIds,
                isCoachPage = true
            ) { _, _ -> }

            Box(
                modifier = Modifier
                    .width(
                        if (breakpoint > Breakpoint.LG) 69.percent else if (breakpoint == Breakpoint.LG) 67.percent
                        else if (breakpoint > Breakpoint.MD) 49.percent else 100.percent
                    )
                    .margin(topBottom = if (breakpoint <= Breakpoint.MD) 10.px else 0.px)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .borderRadius(15.px)
                    .boxShadow(
                        offsetY = 1.px,
                        blurRadius = 3.px,
                        color = sitePalette.boxShadowColor.rgb
                    )
                    .padding(
                        leftRight = if (breakpoint >= Breakpoint.LG) 30.px else 15.px,
                        topBottom = if (breakpoint >= Breakpoint.LG) 20.px else 10.px
                    )
            ) {
                Column(modifier = Modifier.fillMaxWidth().fillMaxSize()) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        SectionTitle(sessionName.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() })
                        Row(
                            modifier = Modifier.gap(if (breakpoint < Breakpoint.MD) 10.px else 20.px)
                                .flexWrap(FlexWrap.Wrap),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            if (sessionData.videoFile.isEmpty() && uploadProgress < 0) {
                                Div {
                                    Row(
                                        modifier = Modifier.gap(10.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        if (!disable) {
                                            CommonButton(
                                                text = "Upload Video",
                                                icon = {
                                                    Image(
                                                        src = Res.Images.upload_Cloud_Arrow,
                                                        modifier = Modifier.size(20.px)
                                                    )
                                                },
                                                width = 145.px,
                                                height = 40.px,
                                                borderColor = sitePalette.primary.rgb,
                                                backgroundColor = Colors.Transparent,
                                                textSpanColor = sitePalette.primary.rgb,
                                                onCLick = {
                                                    val fileInput =
                                                        document.createElement("input") as HTMLInputElement
                                                    fileInput.type = "file"
                                                    fileInput.accept = "video/*"
                                                    fileInput.onchange = { event ->
                                                        val selectedFile =
                                                            (event.target as HTMLInputElement).files?.get(
                                                                0
                                                            )
                                                        if (selectedFile != null) {
                                                            uploadFile(selectedFile)
                                                        }
                                                    }
                                                    fileInput.click()
                                                }
                                            )
                                        }
                                    }
                                }


                            } else {
                                if (uploadProgress in 0.0..100.0) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        FaTriangleExclamation(
                                            modifier = Modifier.color(sitePalette.primary.rgb)
                                        )
                                        CustomSpacer(5.px)
                                        FieldTitleTextNormalSimple(
                                            "Closing coaches details page will cancel uploading",
                                            fontSize = 15.px,
                                            fontWeight = 500,
                                            color = sitePalette.primary.rgb
                                        )
                                        CustomSpacer(10.px)
                                        CircularProgressIndicator(
                                            percentage = uploadProgress.toFloat(),
                                            size = 40,
                                            strokeWidth = 5,
                                            fontSize = 10.px,
                                            primaryColor = sitePalette.primary.rgb,
                                            backgroundColor = Colors.LightGray
                                        )
                                    }
                                }
                            }
                            if (!isCustomVideo && !disable) {
                                CommonButton(
                                    text = "Download Audio",
                                    icon = {
                                        Image(
                                            src = Res.Images.download_Cloud_Arrow,
                                            modifier = Modifier.size(20.px)
                                        )

                                    },
                                    width = 146.px,
                                    height = 40.px,
                                    borderColor = sitePalette.primary.rgb,
                                    backgroundColor = Colors.Transparent,
                                    textSpanColor = sitePalette.primary.rgb,
                                    onCLick = {
                                        downloadAudio()
                                    }
                                )
                            }

                            if (!disable && !isCustomVideo) {
                                Div {
                                    Row(
                                        modifier = Modifier.gap(10.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {

                                        CommonButton(
                                            text = "Download Text",
                                            icon = {
                                                Image(
                                                    src = Res.Images.download_Cloud_Arrow,
                                                    modifier = Modifier.size(20.px)
                                                )
                                            },
                                            width = 145.px,
                                            height = 40.px,
                                            borderColor = sitePalette.primary.rgb,
                                            backgroundColor = Colors.Transparent,
                                            textSpanColor = sitePalette.primary.rgb,
                                            onCLick = {
                                                val text = sessionData.text
                                                val blob = Blob(
                                                    arrayOf(text),
                                                    org.w3c.files.BlobPropertyBag(type = "text/plain")
                                                )
                                                val url = URL.createObjectURL(blob)
                                                val link =
                                                    document.createElement("a") as HTMLAnchorElement
                                                link.href = url
                                                link.download = "${sessionName}.txt"
                                                document.body?.appendChild(link)
                                                link.click()
                                                document.body?.removeChild(link)
                                                URL.revokeObjectURL(url)

                                            }
                                        )

                                    }

                                }
                            }

                        }
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .gap(if (window.screen.width < 1060) 10.px else 36.px)
                            .flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            FieldTitleTextNormalSimple(
                                text = "Coach:  ",
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                            FieldTitleTextNormalSimple(
                                text = sessionData.coachName,
                                fontWeight = 600,
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                        }

                        Row(
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(src = Res.Images.timeCircle, modifier = Modifier.size(17.px))
                            CustomSpacer(5.px)
                            FieldTitleTextNormalSimple(
                                text = "Duration:  ",
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                            FieldTitleTextNormalSimple(
                                text = sessionData.recordTime.toLongOrNull()?.let {
                                    (it / 1000).formatSessionMinutes()
                                } ?: "-",
                                fontWeight = 600,
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                        }
                        Row(
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(src = Res.Images.calender, modifier = Modifier.size(17.px))
                            CustomSpacer(5.px)
                            FieldTitleTextNormalSimple(
                                text = if (sessionData.category == "customVideo") "Created:  " else "Recorded:  ",
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                            FieldTitleTextNormalSimple(
                                text = "${sessionData.sessionDateTime.formatSessionDate()} ${sessionData.sessionDateTime.formatSessionHoursAmPm()}",
                                fontWeight = 600,
                                fontFamily = Constants.IBM_FONT,
                                fontSize = 16.px
                            )
                        }

                    }
                    if (!isCustomVideo) {

                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .flexWrap(FlexWrap.Wrap),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            Column(
                                modifier = Modifier.width(
                                    if (window.screen.width < 1300) 100.percent else 49.percent
                                )
                            ) {
                                // Speaking Box
                                SessionEmphasisBreakdown(
                                    keywords = sessionKeywords,
                                    sitePalette,
                                    breakpoint,
                                    isEmotionLoading
                                )
                                SpeakingSub(sessionData, sitePalette)
                            }
                            Column(
                                modifier = Modifier.width(
                                    if (window.screen.width < 1300) 100.percent else 49.percent
                                )
                            ) {
                                // Emotion Box
                                EmotionsBox(sessionData, sitePalette, breakpoint)

                                // Tone Box
                                ToneAnalysisBox(sessionData, sitePalette, breakpoint)

                            }

                        }
                        //  Sentiment Box
                        SentimentBox(sessionData, sitePalette)

                        //   Widgets
                        val selectedWidgetsList = selectedWidgetIds
                            .filterNot { widgetId ->
                                (sessionType == SelectedData.Training || sessionType == SelectedData.Matches) && widgetId == 10
                            }
                            .sorted()
                            .take(8)

                        val screenWidth = window.innerWidth

                        val columns = when {
                            screenWidth < 768 -> 1
                            screenWidth < 1200 -> 2
                            screenWidth < 1600 -> 3
                            else -> 4
                        }.coerceAtMost(selectedWidgetsList.size)

                        val rows = selectedWidgetsList.chunked(columns)

                        val cardWidth = when (columns) {
                            1 -> 100.percent
                            else -> (100.0 / columns).percent
                        }

                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .margin(topBottom = 20.px)
                        ) {
                            rows.forEachIndexed { rowIndex, rowWidgets ->
                                val isLastRow = rowIndex == rows.lastIndex

                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .margin(bottom = if (!isLastRow) 16.px else 0.px),
                                    horizontalArrangement = Arrangement.spacedBy(8.px)
                                ) {
                                    rowWidgets.forEach { widgetId ->
                                        val displayNumber = selectedWidgetsList.indexOf(widgetId) + 1
                                        Box(modifier = Modifier.width(cardWidth).fillMaxHeight()) {
                                            widgetRenderers[widgetId]?.invoke(displayNumber)
                                        }
                                    }

                                    // 🔑 Fill remaining slots with invisible placeholders so row width
                                    // matches other rows exactly (prevents flex-stretch on partial rows)
                                    if (columns > 1) {
                                        repeat(columns - rowWidgets.size) {
                                            Box(
                                                modifier = Modifier
                                                    .width(cardWidth)
                                                    .fillMaxHeight()
                                            )
                                        }
                                    }
                                }
                            }
                        }
                        //      Match Analysis Widget

                        if (sessionType == SelectedData.Matches) {
                            // Check if widget 10 is selected by coach
                            val isWidget10Selected = selectedWidgetIds.contains(10)
                            val widgetNumber = selectedWidgetIds.sorted().indexOf(10) + 1  // This will give 8 if it's the 8th widget

                            MatchAnalysisWidget(
                                data = sessionData.widgetMetrics?.matchAnalysis
                                    ?: SessionMatchAnalysis(),
                                widgetNo = widgetNumber,  // Pass the position number (8) instead of 10
                                widgetName = "Match Analysis Report",
                                widgetColor = Palette.CoachTalkPrimaryBlue.rgbLight,
                                useNumberInsteadOfImage = isWidget10Selected,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .margin(bottom = 20.px)
                            )
                        }
                        //            Summary Box
                        SummaryBox(
                            sessionData,
                            sitePalette,
                            breakpoint,
                            message,
                            disable = disable
                        )
                    }

                    //  Highlights Box
                    Column(
                        modifier = Modifier.fillMaxWidth()
                            .minHeight(
                                when {
                                    isCustomHighlight && sessionData.videoFile.isNotEmpty() -> 1301.px
                                    sessionData.videoFile.isNotEmpty() -> 900.px
                                    else -> 670.px
                                }
                            )
                            .maxHeight(
                                when {
                                    isCustomHighlight && sessionData.videoFile.isNotEmpty() -> 1700.px
                                    sessionData.videoFile.isNotEmpty() -> 1300.px
                                    else -> 1300.px
                                }
                            )
                            .margin(top = 15.px)
                            .borderRadius(12.px)
                            .border(
                                1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.coachDetailsBoxBorder.rgb
                            )
                            .overflow(
                                overflowX = Overflow.Auto,
                                overflowY = if (breakpoint <= Breakpoint.XL) Overflow.Auto else Overflow.Hidden
                            )
                            .padding(16.px)
                            .boxShadow(
                                offsetY = 1.px,
                                blurRadius = 3.px,
                                color = sitePalette.textFieldTextColor.rgb.copyf(alpha = 0.1f)
                            )
                    )
                    {
                        Column(

                            modifier = Modifier.fillMaxHeight()
                                .fillMaxWidth()
//                            .width(if (window.screen.width < 1280) 1050.px else 100.percent)

                        ) {
                            if (isLoading) {
                                Box(
                                    modifier = Modifier.fillMaxSize()
                                        .height(400.px),
                                    contentAlignment = Alignment.Center
                                ) {
                                    ProgressIndicator(50.px)
                                }
                            } else {
                                if (!isCustomVideo || sessionData.videoFile.isNotBlank()) {
                                    debugPrintln("isCustomVideo : $isCustomVideo")
                                    //
                                    FullSessionSectionUI(
                                        breakpoint = breakpoint,
                                        sitePalette = sitePalette,
                                        sessionData = sessionData,
                                        sessionDataCallBack = { sessionData = it },
                                        updateCoachInfo = updateCoachInfo,
                                        message = message,
                                        sessionType = sessionType,
                                        userId = userId,
                                        disable = disable,
                                        isVideoDurationPlaying1 = isVideoDurationPlaying1,
                                        isVideoDurationPlaying1CallBack = {
                                            isVideoDurationPlaying1 = it
                                        },
                                        isPlayingAll = isPlayingAll,
                                        isPlayingAllCallBack = { isPlayingAll = it },
                                        scope = scope,
                                        fullSessionVideo = fullSessionVideo,
                                        fullSessionVideoCallBack = { fullSessionVideo = it },
                                        stopPaginationSizeCallBack = { stopPaginationSize = it },
                                        useOriginalAudio = useOriginalAudio,
                                        useOriginalAudioCallBack = { useOriginalAudio = it },
                                        currentlyPlayingVideoIdCallBack = {
                                            currentlyPlayingVideoId1 = it
                                        },
                                        currentVideoRef1 = currentVideoRef1,
                                        isCustomHighlight = isCustomHighlight,
                                        isCustomHighlightCallBack = { isCustomHighlight = it },
                                        sliderStartTimeCallBack = { sliderStartTime = it },
                                        sliderEndTimeCallBack = { sliderEndTime = it },
                                        sliderStartTime = sliderStartTime,
                                        sliderEndTime = sliderEndTime,
                                        seekTimeForHighlightCallBack = {
                                            seekTimeForHighlight = it
                                        },
                                        seekTimeForHighlight = seekTimeForHighlight,
                                        seekWhenPausedCallBack = { seekWhenPaused = it },
                                        seekWhenPaused = seekWhenPaused,
                                        highlightSegments = highlightSegments,
                                        highlightSegmentsCallback = { highlightSegments = it },
                                        fullAudio = fullAudio,
                                        getSentenceAudio = getSentenceAudio,
                                        playAllAudio = playAllAudio,
                                        currentAudioRefHighlight1 = currentAudioRefHighlight1,
                                        playVideoWithAudioFun = { video, audio ->
                                            playVideoWithAudio(
                                                video,
                                                audio,

                                                )
                                        },
                                        currentVideoTimeCallBack = { currentVideoTime = it },
                                        currentVideoTime = currentVideoTime,
                                        isBuffering1 = isBuffering1,
                                        videoProgress1 = videoProgress1,
                                        videoProgressCallBack = { videoProgress1 = it },
                                        allowProgressUpdateCallBack = { allowProgressUpdate = it },
                                        manualSeekTriggeredCallBack = { manualSeekTriggered = it },
                                        selectedKeyword = selectedKeyword,
                                        selectedKeywordCallBack = { selectedKeyword = it },
                                        getSentences = getSentences,
                                        getSentencesCallBack = {
                                            getSentences.clear(); getSentences.addAll(
                                            it
                                        )
                                        },
                                        loadingSessionIdFullSession = loadingSessionIdFullSession,
                                        loadingSessionIdFullSessionCallBack = {
                                            loadingSessionIdFullSession = it
                                        },
                                        isAudioDurationPlaying = isAudioDurationPlaying,
                                        isAudioDurationPlayingCallBack = {
                                            isAudioDurationPlaying = it
                                        },
                                        currentAudioRefFullSession = currentAudioRefFullSession,
                                        currentlyPlayingIdFullSession = currentlyPlayingIdFullSession,
                                        currentlyPlayingIdFullSessionCallBack = {
                                            currentlyPlayingIdFullSession = it
                                        },

                                        fullPlayAudioProgress = fullPlayAudioProgress,
                                        fullPlayAudioProgressCallBack = {
                                            fullPlayAudioProgress = it
                                        },

                                        fullPlaySessionId = fullPlaySessionId,

                                        currentlyPlayingIdHighlight = currentlyPlayingIdHighlight,
                                        currentlyPlayingIdHighlightCallBack = {
                                            currentlyPlayingIdHighlight = it
                                        },

                                        currentKeywordSegmentIndex = currentKeywordSegmentIndex,
                                        currentKeywordSegmentIndexCallBack = {
                                            currentKeywordSegmentIndex = it
                                        },

                                        isPlayingAllSegments = isPlayingAllSegments,
                                        isPlayingAllSegmentsCallBack = {
                                            isPlayingAllSegments = it
                                        },

                                        showNames = showNames,
                                        showNamesCallBack = { showNames = it },

                                        selectedName = selectedName,
                                        selectedNameCallBack = { selectedName = it },

                                        currentSentenceIndex = currentSentenceIndex,
                                        currentSentenceIndexCallBack = {
                                            currentSentenceIndex = it
                                        },

                                        currentSegmentTime = currentSegmentTime,
                                        currentSegmentTimeCallBack = { currentSegmentTime = it },

                                        namesList = namesList,

                                        sessionKeywords = sessionKeywords,
                                        sessionKeywordsCallBack = {
                                            sessionKeywords.clear()
                                            sessionKeywords.addAll(it)
                                        },

                                        playAllHide = playAllHide,
                                        playAllHideCallback = { playAllHide = it },

                                        hasClosedCustomHighlightCallBack = {
                                            hasClosedCustomHighlight = it
                                        },

                                        isSentenceLoading = isSentenceLoading,
                                        isSentenceLoadingCallBack = { isSentenceLoading = it },

                                        players = players,
                                        coaches = coaches,
                                        isAudioLoading = isAudioLoading,
                                        isAudioLoadingCall = {isAudioLoading = it}, playAllJob = playAllJob,
                                        playAllJobCallBack = {playAllJob = it},
                                        playAllSentencesSequentially = { sentences, videoElement, onFinished ->
                                            playAllSentencesSequentially(
                                                sentences = sentences,
                                                audioElement = playAllAudio,
                                                videoElement = videoElement,
                                                onPlaybackFinished = onFinished
                                            )
                                        }
                                    )
                                    //
                                } else {
                                    Box(
                                        modifier = Modifier.fillMaxSize(),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        FieldTitleTextNormalSimple(
                                            "Please upload a Video to view the full session.",
                                            fontWeight = 600,
                                            fontSize = 15.px,
                                            width = 100.percent,
                                            textAlign = TextAlign.Center,
                                        )
                                    }
                                }
                            }
                        }
                    }

//

                    Input(
                        type = InputType.File,
                        attrs = {
                            id(Res.Id.fileInput)
                            style {
                                display(DisplayStyle.None)
                            }
                            accept("video/*")  // Restrict to video files only
                            onChange { event ->
                                val files = (event.target).files
                                if (files != null && files.length > 0) {
                                    val file = files[0]
                                    if (file != null) {
                                        val reader = FileReader()
                                        reader.onload = { e ->
                                            val result = e.target?.asDynamic()?.result as? String
                                            if (result != null) {
                                                uploadedVideoUrl = result
                                            }
                                        }
                                        reader.readAsDataURL(file as Blob) // ✅ cast to Blob
                                    }
                                }
                            }
                        }
                    )

                }
            }
        }
    }
}


